package dev.lingvo.site.components.studio.compose

import dev.lingvo.shared.RenderFitDto
import dev.lingvo.shared.screenshots.doc.TextContent
import dev.lingvo.shared.screenshots.render.RenderReport

/** Caption-free exports carry neutral positive fit metadata accepted by R21. */
fun renderUploadFit(report: RenderReport, floorPx: Double, schemaVersion: Int = 1): RenderFitDto {
    val primary = report.texts.firstOrNull { it.primaryCaption }
        ?: if (schemaVersion < 3) report.texts.firstOrNull { it.content is TextContent.SlotCaption } else null
    val caption = primary ?: return RenderFitDto(1.0, 1.0, report.blocking, 0)
    return RenderFitDto(caption.fit.layout.size, floorPx, report.blocking, caption.fit.layout.lines.size)
}
